import { motion } from 'framer-motion';
import { MapPin, Heart, Instagram, Mail } from 'lucide-react';

const EMAIL = "fkhizra232@gmail.com";
const INSTAGRAM = "https://instagram.com/artcreativevallye_";

const Footer = () => {
  return (
    <footer className="py-12 border-t border-[#D4AF37]/10" data-testid="footer">
      <div className="section-container">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo & Tagline */}
          <div className="text-center md:text-left">
            <p className="font-cinzel text-xl text-gold-gradient mb-1">Ethereal Calligraphy</p>
            <p className="font-manrope text-sm text-[#D4AF37]/70 mb-1">Art Create Valley</p>
            <p className="font-manrope text-xs text-gray-500">
              Handcrafted Islamic Art
            </p>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <motion.a
              href={INSTAGRAM}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center text-gray-400 hover:text-[#D4AF37] hover:bg-[#D4AF37]/20 transition-all"
              whileHover={{ scale: 1.1 }}
              data-testid="footer-instagram"
            >
              <Instagram size={18} />
            </motion.a>
            <motion.a
              href={`mailto:${EMAIL}`}
              className="w-10 h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center text-gray-400 hover:text-[#D4AF37] hover:bg-[#D4AF37]/20 transition-all"
              whileHover={{ scale: 1.1 }}
              data-testid="footer-email"
            >
              <Mail size={18} />
            </motion.a>
          </div>

          {/* Location Badge */}
          <motion.div
            className="flex items-center gap-2 px-4 py-2 rounded-full border border-[#D4AF37]/20 bg-[#D4AF37]/5"
            whileHover={{ scale: 1.05 }}
          >
            <MapPin size={16} className="text-[#D4AF37]" />
            <span className="font-manrope text-sm text-gray-300">
              Available in Hyderabad Only
            </span>
          </motion.div>
        </div>

        {/* Bottom Line */}
        <div className="mt-8 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-manrope text-xs text-gray-600">
            © 2024 Ethereal Calligraphy - Art Create Valley. All artworks are original and protected by copyright.
          </p>
          <div className="flex items-center gap-2 text-gray-500 text-sm">
            <span className="font-manrope text-xs">Made with</span>
            <Heart size={12} className="text-[#D4AF37] fill-[#D4AF37]" />
            <span className="font-manrope text-xs">in Hyderabad</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
